// extracted by mini-css-extract-plugin
export default {"markdown":"MzrfLZ2MPOgYHAMiGbzW"};